import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearRescheduleErrorAction = (state: PlanboardState) => {
  state.lastRescheduleError = null;
};
